/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * A function that merges input classes using clsx and tailwind-merge.
 *
 * @param inputs - the classes to merge
 */
const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs))
}

export { cn }
